import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANNON_KEY;
// VARIABLES
export const CDN_URL = import.meta.env.VITE_SUPABASE_URL +
  "/storage/v1";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const getUser = async () => {
  const { data: userData, error: userError } = await supabase.auth.getUser();

  if (userError) {
    throw new Error("Error getting user: " + userError.message);
  }

  return userData?.user;
};

export const getTableByUserId = async (
  userCalled: string,
  userId: string,
  table: string,
) => {
  try {
    if (!table) {
      throw new Error("Table name is undefined");
    }

    const { data, error } = table === "projects"
      ? await supabase.from(table).select("*").eq(userCalled, userId)
      : await supabase.from(table).select("*").eq(userCalled, userId).single();
    if (error) {
      throw new Error(
        `Error fetching user with ID ${userId}: ${error.message}`,
      );
    }

    return data;
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }
};
